import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { CSSProperties, ReactNode } from 'react';
import ReactDOM from 'react-dom';

interface LimitedOverlayProps {
  element?: Element | null;
  height?: number | string;
  description?: ReactNode;
  isCreatePortal?: boolean;
  translate?: (key: string, options?: Record<string, unknown>) => string;
  content?: ReactNode;
  style?: CSSProperties;
}

const LimitedOverlay = ({
  element,
  height = 112,
  description,
  isCreatePortal = true,
  translate,
  content,
  style,
}: LimitedOverlayProps) => {
  const getDescription = () => {
    if (description) return description;
    if (translate) {
      return (
        <span
          dangerouslySetInnerHTML={{
            __html: translate('settings.contactToUnlock').replace(
              '<a>',
              '<a href="mailto:support@klayo.com">'
            ),
          }}
        />
      );
    }
    return (
      <>
        Contact <a href='mailto:support@klayo.com'>support@klayo.com</a> to discuss unlocking all
        Klayo Intelligence.
      </>
    );
  };

  if (!isCreatePortal)
    return (
      <StyledLimitedOverlay height={height} style={style}>
        {content ?? <Typography variant='body1'>{getDescription()}</Typography>}
      </StyledLimitedOverlay>
    );

  if (!element) {
    return <></>;
  }

  return ReactDOM.createPortal(
    <StyledLimitedOverlay height={height} style={style}>
      {content ?? <Typography variant='body1'>{getDescription()}</Typography>}
    </StyledLimitedOverlay>,
    element
  );
};

const StyledLimitedOverlay = styled.div<{ height: number | string }>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
  backdrop-filter: blur(1.5px);
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
`;

export default LimitedOverlay;
